export default __webpack_public_path__ + "static/media/5.f9c48b4e.svg";